(ns yardwerkz.capra.api-spec
  "Shared keyword set of all API methods exposed via Capra.
   Source of truth for client stub generation and server validation.

   Read by:
   - gen-stubs macro (frontend compile time, JVM)
   - Server startup validation (runtime)")

(def api-methods
  "All method keywords exposed to clients.
   Source of truth for gen-stubs (frontend) and server validation."
  #{;; Auth
    :auth/login :auth/me

    ;; Job lifecycle (mutations)
    :job/create :job/submit :job/cancel :job/accept
    :job/start-en-route :job/start-work :job/finish-work
    :job/complete :job/complete-work :job/approve-work
    :job/dispute :job/resolve
    :job/update-tracking

    ;; Job queries
    :job/get :job/list :job/list-available :job/match-workers
    :job/get-workflow-state

    ;; Quote
    :quote/create :quote/accept :quote/decline :quote/withdraw
    :quote/list-for-job :quote/list-my-quotes

    ;; Property / yard / photo
    :property/create :property/update :property/delete :property/list
    :yard/create :yard/update :yard/delete :yard/list
    :photo/create :photo/delete :photo/list

    ;; Service
    :service/list

    ;; Message
    :message/send :message/mark-all-read
    :message/list :message/conversations

    ;; Notification
    :notification/mark-read :notification/mark-all-read
    :notification/register-push-token :notification/remove-push-token
    :notification/update-preferences
    :notification/list :notification/get-unread-count
    :notification/get-preferences

    ;; Rating
    :rating/create :rating/respond
    :rating/list-received :rating/list-given

    ;; Account
    :account/update :account/delete

    ;; Worker
    :worker/update-profile :worker/update-location
    :worker/configure-service
    :worker/set-slot-availability :worker/remove-slot-availability
    :worker/bulk-set-availability
    :worker/start-onboarding
    :worker/get-profile :worker/list-jobs
    :worker/get-availability :worker/get-services

    ;; Customer
    :customer/get-stats

    ;; Payment
    :payment/create-checkout-intent :payment/confirm
    :payment/create-setup-intent :payment/confirm-setup-intent
    :payment/get-payment-methods :payment/set-default-payment-method
    :payment/delete-payment-method
    :payment/start-onboarding :payment/refresh-onboarding-link
    :payment/get-worker-balance :payment/get-dashboard-link
    :payment/get-stripe-status
    :payment/get :payment/list-by-customer

    ;; Geo
    :geo/calculate-area

    ;; Custom (hand-crafted server methods)
    :job/create-and-submit

    ;; Subscription methods
    :sub/job :sub/quote :sub/property :sub/yard :sub/message
    :sub/customer-jobs :sub/worker-jobs
    :sub/job-quotes :sub/job-messages
    :sub/notifications :sub/unread-count
    :sub/job-tracking :sub/customer-properties :sub/property-yards
    :sub/services :sub/available-jobs})

(def internal-only-actions
  "Actions NOT exposed via Capra — admin/system use only."
  #{:job/delete :job/mark-paid
    :payment/create-intent :payment/capture :payment/cancel
    :payment/refund :payment/mark-paid
    :service/upsert :photo/get})

(def unexposed-actions
  "Dispatch-registered actions not exposed to clients.
   Kept server-side for backward compat or future use.
   Aliases, duplicates, and dead-code actions pruned from api-methods."
  #{;; Aliases of used actions
    :user/profile :job/assign :job/approve :job/en-route :job/raise-dispute
    :notification/read :notification/read-all
    ;; Duplicate query names (frontend uses the other name)
    :notification/preferences :notification/unread-count
    :rating/submit :job/available :message/read :message/unread-count
    ;; Dead queries
    :job/detail :job/list-customer :job/list-worker
    :customer/get :worker/get :worker/get-stats :worker/get-balance
    :worker/find-available :quote/get :property/get :property/find-nearby
    :service/get :yard/get :rating/get-for-job :rating/get-for-worker
    :rating/get-for-customer :rating/summary :payment/list-for-job
    :payment/get-by-job :payment/get-readiness
    ;; Dead mutations
    :job/update :job/close :job/set-pricing :quote/expire
    :customer/update-stripe :worker/update-payout-preferences
    :worker/set-availability :worker/remove-availability
    ;; Cross-namespace aliases
    :account/register-push-token :account/remove-push-token
    :account/update-notification-prefs
    :customer/ensure-stripe :customer/ensure-stripe-customer
    :customer/list-payment-methods :customer/create-setup-intent
    :worker/refresh-onboarding-link :worker/get-account-status
    :worker/get-stripe-balance :worker/get-dashboard-link})
